"use client";

import { getEnv, getInitialCountryCode } from "@/00-shared/const";
const disableFetchPathList = ["/api/stream", "/api/pageViewReport", "/api/v3/additional/service/ai_chat/conversation/message", "/api/captcha", "/api/upload/additional/service/upload_file/v2"];
function isDisableFetch(url: string) {
  return disableFetchPathList.some(path => url.startsWith(path));
}

// 确保所有代码都在客户端执行
if (typeof window !== "undefined") {
  const originalFetch = window.fetch;
  const isProd = getEnv() === "prod";
  window.fetch = async (...args) => {
    const [resource, config] = args;
    const start = Date.now();
    if (resource.toString().includes("vod")) {
      return originalFetch(resource as RequestInfo, config);
    }
    const newConfig = {
      ...config,
      headers: {
        "x-biyi-data-region": getInitialCountryCode(),
        ...config?.headers
      }
    };
    const res = await originalFetch(resource as RequestInfo, newConfig);
    const url = resource.toString();
    if (url.includes("api") && isProd && !isDisableFetch(url)) {
      const proxy = new Proxy(res, {
        get(target, prop, receiver) {
          switch (prop) {
            case "json":
            case "text":
            case "blob":
            case "arrayBuffer":
            case "formData":
              return async (...methodArgs: any[]) => {
                const bodyStart = Date.now();
                const result = await (target as any)[prop](...methodArgs);
                const end = Date.now();
                originalFetch("/api/latencLog", {
                  method: "POST",
                  body: JSON.stringify({
                    cost: end - start,
                    // 总耗时
                    download_cost: end - bodyStart,
                    // 只下载 body 的耗时
                    status: res.status,
                    type: "client_api_cost",
                    method: config?.method,
                    path: resource,
                    timestamp: Date.now(),
                    browser_date: new Date().toLocaleString(),
                    trace: res.headers.get("sentry-trace"),
                    biz_code: result?.base_resp?.code ?? 0
                  })
                });
                return result;
              };
            default:
              try {
                const result = Reflect.get(target, prop, receiver);
                return result;
              } catch (error) {
                console.error("error=>", error);
                return res;
              }
          }
        }
      });
      return proxy;
    }
    return res;
  };
}
export function FetchInterceptor() {
  return null;
}